import React from "react";
import { InputGroup, Typography } from "@icecreamsocial/components";
import { useIntl } from "react-intl";
import { Checkbox } from "@material-ui/core";
import { useAtom } from "jotai";
import { requiredConsentAtom } from "../../../../shared/atoms";
import { ConsentEditButton } from "../ConsentEditButton";

export const EmailConsentCheckbox = ({ formik, ctx, ...props }) => {
  const [requireConsent] = useAtom(requiredConsentAtom);
  const intl = useIntl();
  const CONTACT_CONSENT_EMAIL = intl.formatMessage(
    {
      id: "contact.consent.email",
      defaultMessage: "Email updates to <underlined>{email}</underlined>",
      description:
        "Label for checkbox to allow ICS to send email to the provided address"
    },
    {
      underlined: str => (
        <Typography.Span textDecoration="underline">{str}</Typography.Span>
      ),
      email: formik.values.email
    }
  );

  const CONTACT_CONSENT_EMAIL_HINT = intl.formatMessage(
    {
      id: "contact.consent.hint.email",
      defaultMessage: "Email updates to {email}",
      description:
        "A popover hint equivalent for contact.consent.email.  This only shows on hover in case the text is cutoff.  This needs to be plaintext so we cannot reuse the contact.consent.email translation"
    },
    {
      email: formik.values.email
    }
  );

  return formik.values.email ? (
    <InputGroup {...props}>
      <Checkbox
        name="emailConsent"
        color="primary"
        value={formik.values.emailConsent}
        checked={formik.values.emailConsent === true}
        onClick={formik.handleChange}
        required={requireConsent.email}
      />
      <InputGroup.Label
        title={CONTACT_CONSENT_EMAIL_HINT}
        overflow="hidden"
        style={{ textOverflow: "ellipsis" }}
      >
        {CONTACT_CONSENT_EMAIL}
      </InputGroup.Label>
      <ConsentEditButton onClick={() => ctx.back(formik.values)} />
    </InputGroup>
  ) : null;
};
